import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import ScenarioOptionLabel from "./ScenarioOptionLabel";


const styles = theme => ({
  field: {
    minWidth: 130,
    maxWidth: 350,
  },
  empty: {
    color: theme.palette.text.disabled,
  },
});


@withStyles(styles)
@observer
class ScenarioSelect extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    scenarioId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onScenarioChange: PropTypes.func.isRequired,
    onScenarioSelect: PropTypes.func,
    choices: PropTypes.any.isRequired,
    fullWidth: PropTypes.bool,
  };

  static defaultProps = {
    label: 'Scenario',
    scenarioId: null,
    fullWidth: false,
  };

  render() {
    const {
      label, scenarioId, onScenarioChange, onScenarioSelect, choices, fullWidth, classes,
    } = this.props;
    return (
      <TextField
        select
        label={label}
        value={scenarioId === null ? '' : scenarioId}
        variant="outlined"
        onChange={onScenarioChange}
        onClick={onScenarioSelect}
        disabled={choices.length === 0}
        fullWidth={fullWidth}
        className={fullWidth ? '' : classes.field}
      >
        {choices.map(({ value, display_name }) => {
          if (value === null) {
            return (
              <MenuItem key={value} value="">
                <Typography className={classes.empty}>{display_name}</Typography>
              </MenuItem>
            );
          }
          return (
            <MenuItem key={value} value={value}>
              <ScenarioOptionLabel scenarioId={value} />
            </MenuItem>
          );
        })}
      </TextField>
    );
  };
}


export default ScenarioSelect;
